import React from 'react'
import Image from '../../../images/sellerpolicies/16.png'

const Requirments_for_registration = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Requirments for Registration</h2>
            <p>To successfully complete the Signup Process, the vendor has to register themselves in the category of Business to the customer and the following is the required information for completing the signup process.</p>
            <ul>
                <li>•	Business name</li>
                <li>•	Business Contact person</li>
                <li>•	CNIC</li>
                <li>•	Operational Bank account</li>
                <li>•	Valid Pick-up address</li>
                <li>•	Operational Contact Number</li>
                <li>•	Valid Email Address</li>
            </ul>
            <p>The Seller is responsible for maintaining up-to-date information, including address and bank account number. KAAY is not responsible for any liability arising from incorrect information supplied by the Seller.</p>
            <p>After the successful signup process seller will set up their shop at KAAY by uploading their products. The pictures of the product should be according to the image policy of KAAY. Ensure your shop content, such as any text, Product photos used to represent yourself or your product, your shop, or your listings, abide by KAAY’s polices.</p>
        </div>
      </div>
    </div>
  )
}

export default Requirments_for_registration
